export default "__VITE_ASSET__CILXsVJ8__"